import RowSummary from '../row-summary/row-summary';
import { DirectionsRequirement } from '../../types/data';

type TableSummaryProps = {
  data: DirectionsRequirement[];
};

function TableSummary({ data }: TableSummaryProps) {
  return (
    <div className="no-outer-borders max-h-[calc(100vh-245px)] w-[100%] overflow-y-auto rounded-md bg-white shadow">
      <table className="w-[100%] table-fixed border-collapse border bg-white">
        <thead className="bg-white">
          <tr>
            <th className="border border-gray-400 px-2.5 py-4 text-center text-xs font-medium">
              Направление
            </th>
            <th className="border border-gray-400 px-2.5 py-4 text-center text-xs font-medium">
              Факт
            </th>
            <th className="border border-gray-400 px-2.5 py-4 text-center text-xs font-medium">
              I кв.
            </th>
            <th className="border border-gray-400 px-2.5 py-4 text-center text-xs font-medium">
              II кв.
            </th>
            <th className="border border-gray-400 px-2.5 py-4 text-center text-xs font-medium">
              III кв.
            </th>
            <th className="border border-gray-400 px-2.5 py-4 text-center text-xs font-medium">
              IV кв.
            </th>
          </tr>
        </thead>

        <tbody>
          {data.length > 0 &&
            data.map((element, index) => (
              <RowSummary key={index} {...element} />
            ))}
        </tbody>
      </table>
    </div>
  );
}

export default TableSummary;
